module.exports = __webpack_public_path__ + "img/Canaan.a7875bff.png";